import React from "react";
import {
    Typography,
    Grid,
    Stack,
    Box,
} from "@mui/material";
import MainCard from "../common/MainCard/MainCard";

// MUI Icons
import PeopleIcon from '@mui/icons-material/People';
import ManIcon from '@mui/icons-material/Man';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ApartmentIcon from '@mui/icons-material/Apartment';

const fontFamily = 'Roboto, Helvetica, Arial, sans-serif';

const GetIcon = (iconType) => {
    switch (iconType) {
        case "people":
            return <ManIcon fontSize="large" />;
        case "time":
            return <AccessTimeIcon fontSize="large" />;
        case "school":
            return <ApartmentIcon fontSize="large" />;
        default:
            return <></>;
    }
}


const Component = ({
    title, value, color, icon, formatFunc,
}) => {

    // Add comma to value 
    let valueStr = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (formatFunc !== undefined) {
        valueStr = formatFunc(value);
    }


    let iconComponent = GetIcon(icon);

    // Check if the background color is dark or light
    const isDarkBackground = (() => {
        // Remove '#' if present and handle short hex
        let hex = color.replace('#', '');
        if (hex.length === 3) {
            hex = hex.split('').map(x => x + x).join('');
        }
        if (hex.length !== 6) return false; // fallback

        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        // Perceived luminance formula
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        return luminance < 0.5;
    })();

    let fontColor = isDarkBackground ? "#ffffff" : "#000000";
    // if (color === "#ffffff" || color === "#ffff") {
    //     fontColor = "#000000";
    // }


    return (<MainCard border={false} boxShadow={true}
        contentSX={{
            p: 1, "&:last-child": { pb: 1 }
        }} sx={{ backgroundColor: color, p: 0 }}>
        <Stack direction="row">
            {/* Icon */}
            <Box sx={{ pr: 1, alignContent: "center" }}>
                {iconComponent}
            </Box>

            {/* Information */}
            <Stack>
                <Typography fontSize={12} fontWeight={800} sx={{ color: fontColor }}>
                    {title}
                </Typography>
                <Grid container alignItems="center">
                    <Grid item>
                        <Typography sx={{ fontFamily: `${fontFamily}`, color: fontColor }} fontSize={35} fontWeight={400}>
                            {valueStr}
                        </Typography>
                    </Grid>
                </Grid>
            </Stack>
        </Stack>

    </MainCard>);

}

export default Component;


